import React, {useState, useEffect} from "react";
import styled from "styled-components"
import { useNavigate } from "react-router-dom";
import useTokenStore from "../Store/Store";
import Prev from "../../img/PrevBlack.png"
import DeleteImg from "../../img/Delete.png"
import axios from "axios";
import MenuEx from "../../img/naga.png"
import { useCookies } from 'react-cookie';
import CompanyInfo from "../MenuCompo/CompanyInfo";
import { useLocation } from "react-router-dom";

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:column;
        background-color:#ffffff;
    `,
    HeaderWrap:styled.div`
        width:100%;
        height:56px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
        position:fixed;
        z-index:3;
        background-color:#ffffff;
    `,
        Header:styled.div`
            width:90%;
            height:56px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            PrevBtn:styled.div`
                width:24px;
                height:24px;
                &:hover{
                    cursor:pointer;
                }
            `,
                PrevImg:styled.img`
                    width:100%;
                    height:100%;
                `,
            HeaderText:styled.p`
                font-size:20px;
                font-weight:600;
                color:#000000;
                margin:0px;
                font-family:'PreFont';
            `,
        InfoWrap:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:center;
            align-items:center;
            flex-direction:column;
            margin-top:36px;
            padding-top:20px;
            padding-bottom:20px;
            border-bottom:1px solid #eeeeee;
        `,
            InfoBox:styled.div`
                width:100%;
                height:auto;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:column;
            `,
            InfoTitleWrap:styled.div`
                width:100%;
                height:auto;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
                margin-bottom:10px;
            `,
            InfoTextWrap:styled.div`
                width:100%;
                height:17px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
                margin-bottom:8px;
            `,
                InfoLeftBox:styled.div`
                    width:62.5%;
                    height:100%;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                    InfoTitle:styled.p`
                        font-size:16px;
                        font-weight:500;
                        color:#181818;
                        margin:0px;
                        font-family:'PreFont';
                    `,
                    InfoText:styled.p`
                        font-size:14px;
                        font-weight:500;
                        color:#929292;
                        margin:0px;
                        font-family:'PreFont';
                    `,
                InfoRightBox:styled.div`
                    width:37.5%;
                    height:100%;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                    InfoTitleRight:styled.p`
                        font-size:14px;
                        font-weight:500;
                        color:#181818;
                        margin:0px;
                        font-family:'PreFont';
                    `,
                    InfoTextRight:styled.p`
                        font-size:14px;
                        font-weight:400;
                        color:#929292;
                        margin:0px;
                        font-family:'PreFont';
                    `,
            Footer:styled.div`
                width:90%;
                height:auto;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:column;
                padding-top:28px;
            `,
                OrderTimeTitle:styled.p`
                    font-size:14px;
                    font-weight:400;
                    color:#979797;
                    margin:0px;
                    font-family:'PreFont';
                `,
                OrderTime:styled.p`
                    font-size:14px;
                    font-weight:400;
                    color:#979797;
                    margin:0px;
                    font-family:'PreFont';
                `,
}
const OrderListDetail=()=>{
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
    const [IDcookies, setIDcookies, removeIDcookies] = useCookies(["restaurant_id"]);
    const [Restaurant_PK, setRestaurant_PK] = useState(undefined)
    const [Table_PK, setTable_PK] = useState(undefined)
    const location = useLocation();
    const { order } = location.state || {};
    const [ApiData, setApiData] = useState([])
    const navigate = useNavigate();
    
    useEffect(() => {
        if (IDcookies["restaurant_id"]) {
            const first = IDcookies["restaurant_id"].substring(0, 36);     // 앞 절반
      const second = IDcookies["restaurant_id"].substring(36);       // 뒤 절반
  
      setRestaurant_PK(first);
      setTable_PK(second);
        } else {
            console.log("ID 값이 없습니다.");
        }
    }, [IDcookies["restaurant_id"]]);

    useEffect(() => {
        if (order) {
          // 전달받은 order로 원하는 처리
          console.log("받은 주문 데이터:", order);
        }
      }, [order]);


    const axiosInstance = axios.create({
        baseURL: 'https://zzikgomainapi.co.kr/',
    });

    
    const RestaurantCheck = async () => {
        try {
            // const response = await axiosInstance.get("orders/order/?table__id="+Table_PK);
            const response = await axiosInstance.get("business/restaurant/"+Restaurant_PK);

            // business/restaurant/StoreID
            console.log(response.data.tables)
            const result = response.data.tables.find(item => item.id === Number(Table_PK));

            console.log("선택된 테이블:", result);
            // setApiData(response.data.results)
            setApiData(result.orders)
        } catch (error) {
            console.error(error); // 요청에 실패한 경우 에러 메시지 출력
        }
    };

    useEffect(()=>{
        if(Table_PK){
            RestaurantCheck()
        }
    },[Table_PK])

    const [Title, setTitle] = useState({
        "KR":"주문상세내역",
        "EN":"Order history detail",
        "CN":"订单详情",
        "JP":"注文履歴",
        "FR":"détails de commande",
        "SP":"historial de pedidos",
        "GR":"Bestellübersicht",
        "RU":"заказ"
    })
    const [OrderQuantity, setOrderQuantity] = useState({
        "KR":"수량",
        "EN":"Quantity",
        "CN":"数量",
        "JP":"数量",
        "FR":"quantité",
        "SP":"cantidad",
        "GR":"Menge",
        "RU":"количество"
    })
    
    const [ToTal, setToTal] = useState({
        "KR":"총 주문금액",
        "EN":"Total Order Amount",
        "CN":"总订单金额",
        "JP":"総注文金額",
        "FR":"Montant total de la commande",
        "SP":"Importe total del pedido",
        "GR":"Gesamtbestellbetrag",
        "RU":"Общая сумма заказа"
    })

    const [Won, setWon] = useState({
        "KR":"원",
        "EN":"won",
        "CN":"won",
        "JP":"ウォン",
        "FR":"won",
        "SP":"won",
        "GR":"won",
        "RU":"won"
    })

    const [CancelText, setCancelText] = useState({
        "KR":"취소요청",
        "EN":"Cancel",
        "CN":"取消",
        "JP":"Cancel",
        "FR":"Cancel",
        "SP":"Cancelar",
        "GR":"Cancel",
        "RU":"Cancel"
    })

    const [CancelIngText, setCancelIngText] = useState({
        "KR":"취소요청중",
        "EN":"Cancelling",
        "CN":"取消中",
        "JP":"Cancelling",
        "FR":"Cancelling",
        "SP":"Cancelando",
        "GR":"Cancelling",
        "RU":"Cancelling"
    })
    const [CancelEndText, setCancelEndText] = useState({
        "KR":"취소완료",
        "EN":"Cancelled",
        "CN":"已取消",
        "JP":"Cancelled",
        "FR":"Cancelled",
        "SP":"Cancelled",
        "GR":"Cancelled",
        "RU":"Cancelled"
    })

    function formatDateTime(dateTimeString) {
        const date = new Date(dateTimeString);
    
        // 날짜 포맷: 두 자릿수로 맞춤
        const year = String(date.getFullYear()).slice(2); // 연도 뒤 두 자리
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 월 (0부터 시작하므로 +1)
        const day = String(date.getDate()).padStart(2, '0'); // 일
        const hours = String(date.getHours()).padStart(2, '0'); // 시간
        const minutes = String(date.getMinutes()).padStart(2, '0'); // 분
    
        return `${hours}:${minutes}`;
    }

    function formatNumber(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return(
            <Styled.Wrap>
                <Styled.HeaderWrap>
                    <Styled.Header>
                        <Styled.PrevBtn onClick={() => navigate(`/${IDcookies["restaurant_id"]}`)}>
                            <Styled.PrevImg src={Prev}/>
                        </Styled.PrevBtn>
                        <Styled.HeaderText>{Title[Langcookies["PageLang"]]}</Styled.HeaderText>
                        <Styled.PrevBtn />
                    </Styled.Header>
                </Styled.HeaderWrap>
                
                <Styled.InfoWrap>
                    {order.items.map((item, itemIndex) => (
                        <Styled.InfoBox>
                            <Styled.InfoTitleWrap>
                                <Styled.InfoLeftBox>
                                    <Styled.InfoTitle>{item.menu_info.names[Langcookies["PageLang"]]}</Styled.InfoTitle>
                                </Styled.InfoLeftBox>
                                <Styled.InfoRightBox>
                                    <Styled.InfoTitleRight>{item.quantity}개</Styled.InfoTitleRight>
                                    <Styled.InfoTitleRight>{formatNumber(item.menu_info.price)}원</Styled.InfoTitleRight>
                                </Styled.InfoRightBox>
                            </Styled.InfoTitleWrap>
                            {item.selected_additional.map((v, idx) =>(
                                <Styled.InfoTextWrap>
                                    <Styled.InfoLeftBox>
                                        <Styled.InfoText>{Object.keys(v)}</Styled.InfoText>
                                    </Styled.InfoLeftBox>
                                    <Styled.InfoRightBox>
                                        <Styled.InfoTextRight></Styled.InfoTextRight>
                                        <Styled.InfoTextRight>{formatNumber(Object.values(v))}원</Styled.InfoTextRight>
                                    </Styled.InfoRightBox>
                                </Styled.InfoTextWrap>
                            ))}

                        </Styled.InfoBox>
                    ))}
                </Styled.InfoWrap>
                <Styled.Footer>
                    <Styled.InfoBox>
                        <Styled.InfoTitleWrap>
                            <Styled.InfoLeftBox>
                                <Styled.InfoTitle>총 결제금액</Styled.InfoTitle>
                            </Styled.InfoLeftBox>
                            <Styled.InfoRightBox>
                                <Styled.InfoTitleRight></Styled.InfoTitleRight>
                                <Styled.InfoTitleRight>{formatNumber(order.total_costs)}원</Styled.InfoTitleRight>
                            </Styled.InfoRightBox>
                        </Styled.InfoTitleWrap>
                        <Styled.InfoTextWrap>
                            <Styled.InfoLeftBox>
                                <Styled.OrderTimeTitle>주문일시</Styled.OrderTimeTitle>
                            </Styled.InfoLeftBox>
                            <Styled.InfoRightBox>
                                <Styled.InfoTextRight></Styled.InfoTextRight>
                                <Styled.InfoTextRight>{formatDateTime(order.ordered_at)}</Styled.InfoTextRight>
                            </Styled.InfoRightBox>
                        </Styled.InfoTextWrap>
                    </Styled.InfoBox>
                </Styled.Footer>
            </Styled.Wrap>
    )
    
}
export default OrderListDetail